;
/**
 * Main javascript file for ACS China.
 * This file uses revealing module pattern
 */
acs = function($) {

	var transitionSpeed = 300,
		$window = $(window),
		$body   = $('body'),
		getLocatedRegionCookieName  = 'geoLocateRegion',
		getLocatedCityCookieName    = 'geoLocateCity',
		getLocatedContentStorageKey = 'geoContent_2';

    var init = function() {
	    initialiseGlobal();
	    initialiseWidgets();
	    //initialiseCookieWarning();
	    initialiseNews();
	    initialiseSingle();
	    initialiseGeolocatedContent();
	    initialiseEnquiryForm(); 
	    initialiseAircraft();
	    initialiseDestination();
    	initialiseStickyNav();
    };

    /*
     * global
     */
    var initialiseGlobal = function() {
    	
    	//main nav show / hide
    	$('#nav-trigger').click(function(e) {
    		e.stopPropagation();
    		$body.toggleClass('navopen');
    		if ($body.hasClass('navopen')) {
    			$body.one('click', function() {
    				$body.removeClass('navopen move');
        			$('ul.menu li.menu-item-has-children.click').removeClass('click');
    			});
    		}
    	});
    	
    	//on mobile, prevent clicking on top-level menu items which have a sub menu
    	$('ul.menu li.menu-item-has-children > a').click(function(e) {
    		if ($window.width()<980) {
    			e.preventDefault();
			}
    	});

    	//open sub menu on mobile
    	$('ul.menu li.menu-item-has-children').click(function(e) {
    		if ($window.width()<980) {
        		e.stopPropagation();
    			//is the submen open?
    			if ($body.hasClass('move')) {
    				//close submenu
    				$body.removeClass('move');
        			$('ul.menu li.menu-item-has-children.click').removeClass('click');
    			} else {
    				//open submenu
    				$(this).addClass('click');
    				$body.addClass('move');
    			}
			}
    	});
    	
    	//on mobile stop menu closing when we click a link on submenu
    	$('ul.sub-menu a').click(function(e) {
    		if ($window.width()<980) {
        		e.stopPropagation();
			}
    	});
    	
    	//sub menus in secondary menu work different on mobile
    	$('ul#menu-secondary > li > a').click(function(e) {
    		e.preventDefault();
    		if ($window.width()<980) {  
        		e.stopPropagation();  		
    			var $this = $(this).parent().find('.dropdown');
    			$this.slideToggle();
    			$('ul#menu-secondary .dropdown').not($this).slideUp();
			}
    	});    	
    	
    	//toggle the search on mobile
    	$('#search-trigger').click(function(e) {
    		$body.toggleClass('search-bar');
    		$('#searchbox').slideToggle();
    	});
    	
    	//any forms that contain custom checkboxes
    	$('input:radio').screwDefaultButtons({
			image: 'url("/wp-content/themes/acs-china/assets/img/radio.png")',
			width: 36,
			height: 36
		});
    	
    	//any form fields that need a date picker
    	$.datepicker.setDefaults($.datepicker.regional['zh-CN']);
    	$('input.date').datepicker({
    		dateFormat : 'dd/mm/yy'
		});    	     
    	    	
    	//tabbed content
    	if ($('.tabbed').length) {
    		$('.tabbed .tab').click(function() {
    			var $this = $(this),
    				$parent = $this.parent();
    			$this.addClass('active').siblings('.tab').removeClass('active');
    			$this.closest('.tabbed').find('.tabcontent').removeClass('active').eq($this.index()).addClass('active').trigger('visible');
    		});
    		
    		//some tabs have a pulldown on mobile
    		$('.tabbed select').change(function() {
    			var $this = $(this);
    			$this.siblings('.tab').eq($this.prop('selectedIndex')).click();
    		});
    	}
    	
    	//we re-add this each time the height of the document changes. This can happen as images are lazy-loaded in, tabs change etc.
    	onElementHeightChange(document.body, function() {
    		//console.log('caught page height change');
    		initialiseStickyFooter();
    	});
    	
    	//make sure it always fires once
    	initialiseStickyFooter();
    	
    	//for accordions
    	$('.accordion .title').click(function() {
    		var $this = $(this);
    		$this.siblings('.title').removeClass('active').next('.content').slideUp();
    		$this.toggleClass('active').next('.content').slideToggle();
    	});
    	
    	//slide up / down the floating footer content
    	$('#floating-footer .contact').click(function() {
    		var $this = $(this);
    		if ($this.data('url')) {
    			 location.href = $this.data('url');
    		} else {
	    		$('#floating-footer .contact.active').not($this).removeClass('active').find('.contact-slide').slideUp();
	    		$this.toggleClass('active').find('.contact-slide').slideToggle();
    		}
    	});  
    	$('#floating-footer .contact h4').click(function(e) {
    		e.stopPropagation();
    		$(this).parent().slideUp().parent().removeClass('active');
    	});  
    	$('#floating-footer .contact .content').click(function(e) {
    		e.stopPropagation();
    	});
    };
    
    /*
     * Load in content that changes based on the user's location
     */
    var initialiseGeolocatedContent = function() {
	    //geolocate the user's IP
		geoLocate(function(region_name) {
			
			//before retrieving content via ajax we check if we already have it saved in local storage
			var content = store.get(getLocatedContentStorageKey),
				oneday  = 60 * 60 * 24 * 1000,
				expires = Date.now() - oneday;

			//if stored content is older than 24 hours OR for the wrong city, remove it and start again
			if (content && (content.region!=region_name || content.timestamp<expires)) {
				//console.log('geo content from local storage expired or wrong region');
				store.remove(getLocatedContentStorageKey);
				content = false;
			}
			
			if (content) {
				processGeolocatedContent(content);				
			} else {
				//we need to retrieve the content
				$.ajax({
		  		    url: ajax_url,//set in the footer
					dataType: "json",
					type: "GET",
					data: {
						action: 'geo_content',
						region: region_name
					}
				})
				.done(function( content ) {
					//console.log('retrieved geo content ok');
					
					//add the current timestamp to the result
					content.timestamp = Date.now();
					//console.log(content);
					
					//add data to localstorage via the cross-browser library
					store.set(getLocatedContentStorageKey, content);
					
					processGeolocatedContent(content);
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					console.log('Retrieving Geolocated Content failed.');
					console.log( jqXHR );
					console.log( textStatus );
				});
			}            
	    });
    };
    
    /*
     * Apply the content that changes based on the user's location
     */
    var processGeolocatedContent = function(content) {
    	
	   $('#floating-footer .contact.phone .content').html(content.footer_phone_numbers);
	   $('#floating-footer .contact.email .content').html(content.footer_email_addresses);
	   $('#menu-secondary .dropdown0').html(content.header_email_addresses);
	   $('#menu-secondary .dropdown1').html(content.header_phone_numbers);
	   
	   if ($('body.home').length && typeof content.homepage_header_image != 'undefined') {
		   console.log('replacing slider image');
	       $('.wgt_header_carousel .slide.slide0 img').remove();
	       $('.wgt_header_carousel .slide.slide0 .img').remove();
		   $('.wgt_header_carousel .slide.slide0').append(content.homepage_header_image);
	   }
	   
	   //update phone number in header
	   $('#menu-secondary span.phone').text($(content.header_phone_numbers).find('a').first().text());
    };
    
    /*
     * For sticky footer on desktop
     */
    var initialiseStickyFooter = function() {

    	var $footer = $('#floating-footer'), 
			lastScrollTop = 0,
    		stickyOffset = $('#footer').offset().top + 60;//the point at which the footer becomes sticky
		
		//remove any previously added listeners
		$window.off('scroll.acs');
		$window.on('scroll.acs',function(event) {
		   var st = $window.height() + $window.scrollTop();
		   if (st > stickyOffset) {
		       //make footer sticky
			   $footer.addClass('sticky');
		   } else {
			   $footer.removeClass('sticky').removeAttr('style');
		   }
		   lastScrollTop = st;
		}).scroll();//trigger the scroll in case we started scrolled further down
    }; 
    
    /*
     * For sticky main nav on desktop
     * When the page scrolls past the black bar, it sticks
     * when we scroll back up, both the subnav and the main header appear
     */
    var initialiseStickyNav = function() {
    	var lastScrollTop = 0,
    		stickyOffset = $('#header > nav').offset().top;//the point at which the header can be sticky
    		stickyOffset2 = stickyOffset+40;
		$window.on('scroll',function(event) {
		   var st = $window.scrollTop();

		   /*
	       //make nav sticky?
		   $body.toggleClass('sticky-nav', (st > stickyOffset));

		   //if we're scrolling up add the class to show the header
		   $body.toggleClass('sticky-header', (st<lastScrollTop && st>stickyOffset2));*/
		   if (st > stickyOffset) {
			   $body.addClass('sticky-nav');
		   }
		   if (st==0) {
			   $body.removeClass('sticky-nav');
		   }
		   $body.toggleClass('sticky-header', st<lastScrollTop);
		   
		   lastScrollTop = st;
		}).scroll();//trigger the scroll in case we started scrolled further down
    }; 

    /*
     * Widgets
     */
    var initialiseWidgets = function() {
    	
		//header carousel
		var $headercarousel = $('.wgt_header_carousel .owl-carousel');
		if ($headercarousel.length) {
			$headercarousel.owlCarousel({
				items  : 1,
				loop   : true,
				dots   : false,
				nav    : false,
				autoplay : true,
				autoplayTimeout : 10000,
				autoplaySpeed : 1000
			});
	    	
			/*
	    	//when we fill out the mini form, copy the values to the footer form
	    	$('.wgt_header_carousel form').submit(function(e) {
	    		e.preventDefault();
	    		var $this = $(this);
	    		//type - passenger or cargo
	    		$('#footer form.enquiry input[name="aircraft_type"][value="'+$this.data('type')+'"]').click();
	    		//copy field values from mini form to main form
	    		$('#footer form.enquiry input[name="departure"]').val($this.find('input[name="departure"]').val());
	    		$('#footer form.enquiry input[name="destination"]').val($this.find('input[name="destination"]').val());
	    		$('#footer form.enquiry input[name="departure_date"]').val($this.find('input[name="departure_date"]').val());
	    		$('#footer form.enquiry select[name="passengers"]').val($this.find('select[name="passengers"]').val());
	    		$('#footer form.enquiry input[name="total_weight"]').val($this.find('input[name="total_weight"]').val());
	    		//open the enquiry form
	    		$('#floating-footer .contact.enquire').click();
	    		
	    		//fire the event
	    		if ($this.data('type')=='passenger') { 
	    			_hmt.push(['_trackEvent', 'Private Enquiry', 'submit', 'Quick Quote Box']);
	    		} else {//cargo
	    			_hmt.push(['_trackEvent', 'Cargo Enquiry', 'submit', 'Quick Quote Box']);
	    		}
	    	});*/
			
			//track form submission with Baidu
			$('.wgt_header_carousel form').submit(function(e) {
				e.preventDefault();
				quoteForm = this;
				if ($(this).data('type')=='passenger') { 
	    			_hmt.push(['_trackEvent', 'Private Enquiry', 'submit', 'Quick Quote Box']);
	    		} else {//cargo
	    			_hmt.push(['_trackEvent', 'Cargo Enquiry', 'submit', 'Quick Quote Box']);
	    		}
				
				setTimeout(function() {
					quoteForm.submit();
				}, 1000);
		    });
		}
		
		//top aircraft / top destinations
		//and 5 x sub services
		function initTopCarousel($elem) {
			$elem.owlCarousel({
				items  : 2,
				margin : 15,
				loop   : true,
				dots   : true,
				nav    : false,
				responsive : {
				    // breakpoint from 768 up
				    768 : {
				    	items  : 4,
						margin : 20
				    },
				    // breakpoint from 980 up
				    980 : {
				    	items  	  : 4,
						margin 	  : 20,
						dots   	  : false,
						touchDrag : false,
						mouseDrag : false
				    },
				    // breakpoint from 1300 up
				    1300 : {
				    	items  : 5,
						margin : 30
				    }
				}
			});
		}
		
		var $topcarousel = $('.wgt_top .owl-carousel, .wgt_5x_sub_services .owl-carousel');
		if ($topcarousel.length) {
			$topcarousel.each(function() {
				var $this = $(this);
				if ($this.parent().is(':visible')) {
					initTopCarousel($this);
				} else {
					//we want to initialise when the slide becomes visible.
					$this.parent().one('visible', function() {
						initTopCarousel($this);
					});
				}
			});
		}
		
		//4x column mini feed and 4x column large feed
		var $fourminicarousel = $('.wgt_4x_column_mini_feed .owl-carousel, .wgt_4x_column_large_feed .owl-carousel');
		if ($fourminicarousel.length) {
			$fourminicarousel.owlCarousel({
				items  : 2,
				margin : 15,
				loop   : true,
				dots   : true,
				nav    : false,
				responsive : {
				    // breakpoint from 768 up
				    768 : {
				    	items  : 4,
						margin : 20
				    },
				    // breakpoint from 980 up
				    980 : {
				    	items  	  : 4,
						margin 	  : 20,
						dots   	  : false,
						touchDrag : false,
						mouseDrag : false
				    }
				}
			});
		}
		
		//aircraft guide
		if ($('.wgt_aircraft_guide').length) {

    		//infinite scroll
			var $container = $('.aircraftlist'),        		
        		nextPageNumber = 2,//this variable keeps track of our page number
        		filter = '';//any filter
				
    		//init infinite scroll
			$container.infinitescroll({		 
				navSelector  : '.aircraft nav',
			    nextSelector : '.aircraft nav a',
			    itemSelector : '.aircraftlist article',
			    loading: {
			    	msgText: "<p>Loading more aircraft</p>",
			        finishedMsg: "<p>There are no more aircraft to display.</p>",
			        img: '<span class="loading"></span>'
			    },
				behavior: "twitter",
				path: function(pageNumber) {

					//assemble url
					var url = $('form.filter').attr('action');

					//add page number if it's anything other than page 1
					if (nextPageNumber!=1) {
						url += 'page/'+nextPageNumber+'/';
					}
					
					//is there a filter to add on?
					if (filter!='') {
						url += '?'+filter;
					}

					//increment page number
					nextPageNumber++;
					
				    return url;
				}
			});
    		
    		//when we change the category filter
    		$('form.filter select').change(function() {
    			
    			nextPageNumber = 1;
    			
    			//any filter
    			filter = $('form.filter').serialize();
    			
    			//remove existing posts
    			$container.find('article').remove();
    			
    			$container.infinitescroll('reset');
    			
    			//fire the post retrieval
    			$container.infinitescroll('retrieve');
    		});

    		//clicking on the categories link in the header opens the accordion
	    	$('p.categories').click(function() {
	    		$('.accordion.aircraft-categories .title').click();
	    	});
    		
    	}
		
		//offices
		if ($('.wgt_offices').length) {
			//as we move through the tabs we want to update an argument in the url
            //ref: https://stackoverflow.com/questions/486896/adding-a-parameter-to-the-url-with-javascript
			
    		$('.wgt_offices .tabbed .tab').click(function() {
    			setParamUrl('location', $(this).data('location') );// https://some.com/some_path?cat=strData
    		});	    	
		}
		
		//when we click onthe blue button in the 'cta contact' (headset) widget
		if ($('.wgt_cta_contact').length) {
			$('.wgt_cta_contact button').click(function() {
				//type - passenger or cargo
	    		$('#footer form.enquiry input[name="aircraft_type"][value="'+$(this).data('type')+'"]').click();
	    		//open the enquiry form
	    		$('#floating-footer .contact.enquire').click();
			});
		}
	};
	
	/*
	 * replace a parameter in the query string and update via history api
	 * ref: https://stackoverflow.com/questions/486896/adding-a-parameter-to-the-url-with-javascript
	 */
	var setParamUrl = function(key, value) {// replace and add new parameters
		
		key = escape(key); value = escape(value);

        var kvp = document.location.search.substr(1).split('&');
        if (kvp == '') {
        	var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + key + '=' + value;
        } else {
            var i = kvp.length; var x; while (i--) {
                x = kvp[i].split('=');

                if (x[0] == key) {
                    x[1] = value;
                    kvp[i] = x.join('=');
                    break;
                }
            }

            if (i < 0) { kvp[kvp.length] = [key, value].join('='); } 

            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + kvp.join('&');
        }

	    if (history.pushState) { // without reload  
	        window.history.pushState({path:newurl}, null, newurl);
	    }

	};

    /*
     * cookie warning
     */
    var initialiseCookieWarning = function() {

    	var $warning = $('#cookiewarning');
    	if ($warning.length) {
	    	var cookie = Cookies.get('cookiewarning');
	    	if (typeof cookie == 'undefined' || cookie=='') {
	    		setTimeout(function() {
	    			//show the cookie warning;
	    			$warning.slideDown();
	    			Cookies.set('cookiewarning', '1', { expires: 30 });
	    		}, 1000);

	    		//close button
	    		$('#cookiewarning svg.icon').click(function() {
	    			$warning.slideUp();
	    		});
	    	}
    	}
    };

    /*
     * generic infinite scroll
     * appears on news etc
     */
    var initialiseNews = function() {

    	if ($('body.blog, body.archive.category').length) {    		

    		//infinite scroll
			var $container = $('.articlelist'),        		
        		nextPageNumber = 2,//this variable keeps track of our page number
        		filter = '';//any filter
				
    		//init infinite scroll
			$container.infinitescroll({		 
				navSelector  : 'main nav',
			    nextSelector : 'main nav a',
			    itemSelector : '.articlelist article',
			    loading: {
			    	msgText: "<p>其他文章</p>",
			        finishedMsg: "<p>There are no more articles to display.</p>",
			        img: '<span class="loading"></span>'
			    },
				behavior: "twitter",
				path: function(pageNumber) {

					//assemble url
					var url = $('#filter').attr('action');

					//add page number if it's anything other than page 1
					if (nextPageNumber!=1) {
						url += 'page/'+nextPageNumber+'/';
					}
					
					//is there a filter to add on?
					if (filter!='') {
						url += '?'+filter;
					}

					//increment page number
					nextPageNumber++;
					
				    return url;
				}
			});
    		
    		//when we change the category filter
    		$('#filter select').change(function() {
    			
    			nextPageNumber = 1;
    			
    			//any filter
    			filter = $('#filter').serialize();
    			
    			//remove existing posts
    			$container.find('article').remove();
    			
    			$container.infinitescroll('reset');
    			
    			//fire the post retrieval
    			$container.infinitescroll('retrieve');
    		});
    	}
    }
   
    /*
     * Javascript for single article page
     */
    var initialiseSingle = function() {

    	if ($('body.single').length) {  		
    		
    		//for share buttons
    		//twitter
    		$('.share .twitter').click(function(e) {
    			e.preventDefault();
    			showPopup('https://twitter.com/intent/tweet?text='+encodeURIComponent(window.location.href));
    		});
    		//facebook		
    		$('.share .facebook').click(function(e) {
    			e.preventDefault();
    			showPopup('https://www.facebook.com/dialog/share?app_id=353951775355865&display=popup&href='+encodeURIComponent(window.location.href)+'&redirect_uri='+encodeURIComponent(window.location.href));
    		});
    		//linkedin
    		$('.share .linkedin').click(function(e) {
    			e.preventDefault();
    			showPopup('https://www.linkedin.com/cws/share?url='+window.location.href);
    		});
    		
    		/*
    		//google
    		$('#share .google').click(function(e) {
    			e.preventDefault();
    			showPopup('https://plus.google.com/share?url='+encodeURIComponent(window.location.href));
    		});    		
    		*/     	
    	}    	
    };
    
    /*
     * open a popup window
     * Used by share buttons
     */
    var showPopup = function(url) {
    	window.open(url, 'popUpWindow', 'height=435,width=514,left=10,top=10,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no,status=yes');
    };
    
    /*
     * listener for an element changing height.
     * We use the on the document for our sticky footer
     * ref: https://stackoverflow.com/questions/14866775/detect-document-height-change
     */
    var onElementHeightChange = function(elm, callback) {
        var lastHeight = elm.clientHeight, newHeight;
        (function run() {
            newHeight = elm.clientHeight;
            if ( lastHeight != newHeight )
                callback();
            
            lastHeight = newHeight;

            if ( elm.onElementHeightChangeTimer )
                clearTimeout(elm.onElementHeightChangeTimer);

            elm.onElementHeightChangeTimer = setTimeout(run, 300);
        })();
    };
    
    /*
     * looks up the user's IP and returns the region name
     * Stores in a cookie so we don't need to keep hitting the service (slow + rate limited)
     * Uses a callback because the ajax functions is async, so you can pass in an anonymous function
     */
    var geoLocate = function(callback) { 
    	
    	var cookievalue = Cookies.get(getLocatedRegionCookieName);
  		if (cookievalue == null || cookievalue=='')  {
  			
  			//perform the lookup with the geolocate service.  			
  			$.getJSON(ajax_url, { action: 'geo_locate' }, function(response) {
  				//console.log('result of IP lookup: ', response);
  				
  				if (typeof response.city != undefined) {
  					Cookies.set(getLocatedCityCookieName, response.city, { expires: 30 });  					
  				}
  				if (typeof response.region != undefined) {
  					Cookies.set(getLocatedRegionCookieName, response.region, { expires: 30 });
  					callback(response.region);
  				} else {
  					//default is Beijing
  					Cookies.set(getLocatedRegionCookieName, 'Beijing', { expires: 30 });
  					callback('Beijing');
  				}
  			});
  			
      } else {
        //just return the value of the cookie
        callback(cookievalue);
      }
    };
    
    /*
     * For the enquiry form in the footer
     */
    var initialiseEnquiryForm = function() {
    	
		if ($('form.enquiry').length) {			

	    	$('form.enquiry button.back').click(function() {
	    		$(this).closest('form.enquiry').find('ul.form-steps').removeClass('step1 step2 step3').addClass($(this).data('target'));
	    	});
	    	
	    	//as they switch between cargo and passenger, we show / hide some form fields
	    	$('form.enquiry input[name="aircraft_type"]').change(function() {
	    		if (this.value=='passenger') {
	    			$(this).closest('form.enquiry').find('.cargo-field').hide();
	    			$(this).closest('form.enquiry').find('.passenger-field').show();
	    		} else {
	    			$(this).closest('form.enquiry').find('.cargo-field').show();
	    			$(this).closest('form.enquiry').find('.passenger-field').hide();
	    		}
	    	});
	    	/*
	    	//show / hide the relevant state field when they select USA or Canada in the country pulldown
            $('select[name="country"]').on('change', function() {
				var selectedCountry = $(this).val();
            	$('p.state.usa').toggle(selectedCountry=='United States').find('select').prop('disabled', selectedCountry!='United States');
                $('p.state.au').toggle(selectedCountry=='Australia').find('select').prop('disabled', selectedCountry!='Australia');
            });*/
	    	
	    	//when we move from one step to the next, validate the fields
	    	$('form.enquiry button.next').click(function() {
	    		
	    		var $this = $(this),
	    			$form = $this.closest('form.enquiry');
	    		
	    		//don't do anything if the form has already been submitted
	    		if (!$form.hasClass('loading')) {    			
	    			
	    			//get the form data we will submit
	    			var $step = $this.closest('.form-step'),
	    				stepNumber = $step.find('[name="step"]').val(),
	    				data = $step.find(':input').serialize()
	    				nextStep = $this.data('target');
	    			//add the action
	    			data += '&'+$.param({ 'action': 'validate_enquiry_step' });    			
	    			//for second step we need to know whether it's cargo or passenger
	    			if (stepNumber=='2') {
	    				data += '&'+$.param({ 'aircraft_type': $form.find('input[name="aircraft_type"]:checked').val() });  
	    			}
	
	    	    	//add the loading class to the form
	    	    	$form.addClass('loading');
	    	    	
	    			//hide any error messages
	    			$form.find('.errors').empty();
	    			
	    			//track event
	    			var category = 'Private Enquiry';
	    			if ($form.find('input[name="aircraft_type"]:checked').val()=='cargo') {
	    				category = 'Cargo Enquiry';
	    			} else if (stepNumber!='1' && parseInt($form.find('select[name="passengers"]').val(), 10)>19) {
	    				category = 'Group Enquiry';
	    			}    			
	    			_hmt.push(['_trackEvent', category, 'submit', 'Footer Step '+stepNumber]);
	    			
	    			//submit details via ajax
	    			$.ajax({
	    				url: ajax_url,
	    				cache: false,
	    				dataType: "json",
	    				method: "POST",
	    				data: data
	    			}).done(function( result ) {
	    				//got a result
	    				if (result.result && result.result=='success') {//all good
	    					
	    					//move to the next step
	    					$form.find('ul.form-steps').removeClass('step1 step2 step3').addClass(nextStep);
	    					
	    					//scroll to top
	    					$('html, body').animate({ scrollTop: 0 }, 500);
	    					
	    				} else if (result.errors) {//failure - is there a failure array?
	    					$.each( result.errors, function( key, error ) {
	    						$form.find('[name="'+key+'"]').parent().find('.errors').text(error);
	    						//console.log('$form.find([name="'+key+'"])', $form.find('[name="'+key+'"]').length);
	    					});
	    				} else {
							//general error
							console.log('Displaying error message');
	    					$form.html('<p class="response">提交请求时出错。 请稍后再试。</p>');//Error submitting request. Please try again later.
						}
	    			}).fail(function(jqXHR, textStatus, errorThrown) {
	    				console.log('got an error when submitting form');
	    				console.log( jqXHR );
	    				console.log( textStatus );
	    				$form.html('<p class="response">提交请求时出错。 请稍后再试。</p>');//Error submitting request. Please try again later.
	    			}).always(function() {
	    				//remove loading class from form
	    				$form.removeClass('loading');
	    			});	
	    		}
	    	});
	    	
	    	//when we submit the enquiry form
	    	$('form.enquiry').submit(function(e) {
	    		e.preventDefault();
	    		
	    		var $form = $(this);
	    		
	    		//don't do anything if the form has already been submitted
	    		if (!$form.hasClass('loading')) {
	
	    	    	//add the loading class to the form
	    	    	$form.addClass('loading');
	    	    	
	    			//hide any error messages
	    			$form.find('.errors').empty();
	    			
	    			var data = $form.serialize()+'&'+$.param({ 'action': 'submit_enquiry' });
	    			//add geo-lookup city and region if we have it
	    			data += '&'+$.param({ 'region': Cookies.get(getLocatedRegionCookieName) });
	    			data += '&'+$.param({ 'city': Cookies.get(getLocatedCityCookieName) });
	    			
	    			//track event
	    			var category = 'Private Enquiry';
	    			if ($form.find('input[name="aircraft_type"]:checked').val()=='cargo') {
	    				category = 'Cargo Enquiry';
	    			} else if (parseInt($form.find('select[name="passengers"]').val(), 10)>19) {
	    				category = 'Group Enquiry';
	    			}
	    			_hmt.push(['_trackEvent', category, 'submit', 'Footer Step 3']);
	    			
	    			//submit details via ajax
	    			$.ajax({
	    				url: ajax_url,
	    				cache: false,
	    				dataType: "json",
	    				method: "POST",
	    				data: data
	    			}).done(function( result ) {
						console.log(result);
	    				//got a result
	    				if (result.result && result.result=='success') {//all good
	
	    	    			_hmt.push(['_trackEvent', category, 'complete', 'Success']);
	    					
	    					//display success message
	    					$form.replaceWith('<h3>感谢您的在线包机咨询</h3><p>我们的包机专家将尽快给您打电话回应您的查询。他会成为你的专属包机经理，如果您将来想预订，他就是您的主要联系人，监督所有运营细节。我们期待在未来的日子里为您服务，并感谢您选择ACS艾尔环球包机。</p>');
	    					
	    					window.dataLayer.push({
								'event'   	    : 'acsEnquiry',
					            'eventCategory' : category,
							});
							
							//Baidu
							window._agl && window._agl.push(['track', ['success', {t: 3}]])
							
	    				} else if (result.errors) {//failure - is there a failure array?
	    					$.each( result.errors, function( key, error ) {
	    						$form.find('[name="'+key+'"]').parent().find('.errors').text(error);
	    					});
	    				} else {
							//general error
							console.log('Displaying error message');
	    					$form.html('<p class="response">提交请求时出错。 请稍后再试。</p>');//Error submitting request. Please try again later.
						}
	    			}).fail(function(jqXHR, textStatus, errorThrown) {
	    				console.log('got an error when submitting form');
	    				console.log( jqXHR );
	    				console.log( textStatus );
	    				$form.replaceWith('<p class="response">Error submitting request. Please try again later.</p>');
	    			}).always(function() {
	    				//remove loading class from form
	    				$form.removeClass('loading');
	    			});	
	    		}
	    	});
	    	

			//do we have some variables in the url to prepopulate the form with?			
			if (QueryString.aircraft_type=='cargo') {
				$('form.enquiry input[name="aircraft_type"][value="cargo"]').prop("checked", true).change().click().parent('.styledRadio').css('background-position', '0 -36px');
			}
			if (QueryString.departure) {
	    		$('form.enquiry input[name="departure"]').val(decodeURIComponent(QueryString.departure));
			}
			if (QueryString.destination1) {
	    		$('form.enquiry input[name="destination"]').val(decodeURIComponent(QueryString.destination1));
			}
			if (QueryString.departure_date) {
	    		$('form.enquiry input[name="departure_date"]').val(decodeURIComponent(QueryString.departure_date));
			}
			if (QueryString.passengers) {
	    		$('form.enquiry select[name="passengers"]').val(decodeURIComponent(QueryString.passengers));
			}
			if (QueryString.total_weight) {
	    		$('form.enquiry input[name="total_weight"]').val(decodeURIComponent(QueryString.total_weight));
			}
		}
    };

    /*
     * Single aircraft page
     */
    var initialiseAircraft = function() {
    	if ($('.single-aircraft').length) {
    		var $carousel = $('.owl-carousel');
    		if ($carousel.length) {
    			$carousel.owlCarousel({
    				items    : 1,
    				loop     : true,
    				dots     : false,
    				nav      : true,
    				navText  : ['<i class="fal fa-angle-left fa-2x"></i>','<i class="fal fa-angle-right fa-2x"></i>'],
    				autoplay : false,
    				autoplayTimeout : 10000,
    				autoplaySpeed : 1000
    			});
    		}
    		//when we click the quote button
    		$('main>article aside button').click(function() {
    			$('#floating-footer div.contact.enquire').click();
    		});
    	}
    };

    /*
     * Single Destination page
     */
    var initialiseDestination = function() {
    	if ($('.single-destination').length) {
    		//when we click the quote button
    		$('main>article aside button').click(function() {
    			$('#floating-footer div.contact.enquire').click();
    		});
    	}
    };
    
    return{init:init}//return items that are available outside

}(jQuery);


//document ready
jQuery(function() {
	acs.init();
});


